import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "../lib/api";
import { GameItem } from "./GameItem";

export function GameGrid({ params, empty = "Nessun gioco trovato.", onTotal, auto = true }) {
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const sentinel = useRef(null);
  const key = JSON.stringify(params);

  const load = useCallback(
    async (p) => {
      setLoading(true);
      try {
        const r = await api.get("/games", { params: { ...params, page: p, limit: 48 } });
        const list = Array.isArray(r.data?.items) ? r.data.items : [];
        setItems((prev) => (p === 1 ? list : [...prev, ...list.filter((g) => !prev.some((x) => x.slug === g.slug))]));
        setPages(r.data?.pages ?? 1);
        setPage(p);
        if (p === 1 && onTotal) onTotal(r.data?.total ?? 0);
      } catch {
        if (p === 1) setItems([]);
      }
      setLoading(false);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [key]
  );

  useEffect(() => {
    load(1);
  }, [load]);

  useEffect(() => {
    const el = sentinel.current;
    if (!el || !auto) return undefined;
    const io = new IntersectionObserver(
      (es) => {
        if (es[0].isIntersecting && !loading && page < pages) load(page + 1);
      },
      { rootMargin: "500px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [loading, page, pages, load, auto]);

  if (!loading && items.length === 0) return <div className="gg-empty" data-testid="grid-empty">{empty}</div>;

  return (
    <>
      <div id="content" className="gg-grid" data-testid="game-grid">
        {items.map((g) => (
          <GameItem key={g.slug} g={g} />
        ))}
      </div>
      <div ref={sentinel} />
      {loading && <div className="gg-empty"><i className="fa-solid fa-spinner fa-spin" /></div>}
      {!loading && page < pages && (
        <button className="gg-loadmore" onClick={() => load(page + 1)} data-testid="load-more-btn">
          Carica altri giochi
        </button>
      )}
    </>
  );
}

export function StaticGrid({ items }) {
  return (
    <div id="content" className="gg-grid" data-testid="game-grid">
      {items.map((g) => (
        <GameItem key={g.slug} g={g} />
      ))}
    </div>
  );
}
